import { useEffect, useState } from "react";

const Planner = () => {

    return (
        <div className="Calender">
           <h1>Comming Soon</h1>
        </div>
     );
}
 
export default Planner;